import {
  DateRangeFilter,
  dateBetweenFilterFn,
} from "../../../../components/tables/DateRangeFilter";

import { X, Check } from "react-feather";

const tableColumns = [
  {
    Header: "Shipment Rack ID",
    accessor: "shipmentRackId",
  },
  {
    Header: "Total Items On Rack",
    accessor: "totalRackItems",
    disableSortBy: true,
    disableFilters: true,
  },
  {
    Header: "Status",
    accessor: "shipmentRackStatusId",
    Cell: ({ row }) => {
      return row.original.shipmentRackStatus;
    },
  },
  {
    Header: "Updated",
    accessor: "lastUpdated",
    Cell: ({ value }) => {
      return new Date(value).toDateString();
    },
    Filter: DateRangeFilter,
    filter: dateBetweenFilterFn,
  },
  {
    Header: "Has Inbound Plan",
    accessor: "inboundPlanId",
    Cell: ({ value }) => {
      if (value) {
        return <Check color="#4BBF73" size={24} />;
      } else {
        return <X color="#d9534f" size={24} />;
      }
    },
    disableSortBy: true,
    disableFilters: true,
  },
];

export default tableColumns;
